/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
import AppContext from 'context/Context';
import React, { useContext } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FaLink } from 'react-icons/fa';

const TopNavRightSideNavItem = () => {
  const {
    config: { isDark, isRTL, cluster, pdfReportUrl },
    setConfig
  } = useContext(AppContext);

  const downloadReport = () => {
    window.open(pdfReportUrl, '_blank', 'noreferrer');
  };

  const domain = window.location.hostname;
  const clientName = domain?.split('.')[0].toUpperCase();

  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      {/* <Nav.Item as={'li'}>
        <Nav.Link
          className="px-2 theme-control-toggle"
          onClick={() => downloadReport()}
        >
          <OverlayTrigger
            key="left"
            placement={isRTL ? 'bottom' : 'left'}
            overlay={<Tooltip id="ThemeColor">Download report</Tooltip>}
          >
            <div className="theme-control-toggle-label">
              <FontAwesomeIcon icon={faDownload} className="fs-0" />
            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item> */}
      <Nav.Item
        as={'li'}
        style={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        {clientName == 'RPLC' && (
          <a
            style={{
              marginRight: '10px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
            href="https://rplcollaborative.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-decoration-none text-primary"
          >
            <FaLink
              style={{
                marginRight: '5px',
                width: '20px',
                height: '20px'
              }}
            />
            <p
              className="m-0 fw-bold d-none d-md-inline"
              style={{ fontSize: '20px' }}
            >
              Visit website
            </p>
          </a>
        )}
      </Nav.Item>

      <Nav.Item as={'li'}>
        <Nav.Link
          className="px-2 theme-control-toggle"
          onClick={() => setConfig('isDark', !isDark)}
        >
          <OverlayTrigger
            key="left"
            placement={isRTL ? 'bottom' : 'left'}
            overlay={
              <Tooltip id="ThemeColor">
                {isDark ? 'Switch to light theme' : 'Switch to dark theme'}
              </Tooltip>
            }
          >
            <div className="theme-control-toggle-label">
              <FontAwesomeIcon
                icon={isDark ? 'sun' : 'moon'}
                className="fs-0"
              />
            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item>
      {/* <NotificationDropdown /> */}
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
